var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css()},[_c('i',{class:_vm.css('marker'),style:(("background-color: var(--color-" + _vm.color + ")"))}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }